import { Box, Button } from '@ouster/webviz-react-components';

import { FaToolbox } from 'react-icons/fa';

import DashboardCard from './DashboardCard';

type RecordingManagementConsoleProps = {
  handleFetchStale: () => void;
  handleFetchFailed: () => void;
  handleUpdateHWVersion: () => void;
  isLoading: boolean;
};

export default function RecordingManagementConsole({
  handleFetchStale,
  handleFetchFailed,
  handleUpdateHWVersion,
  isLoading,
}: RecordingManagementConsoleProps) {
  return (
    <DashboardCard
      icon={<FaToolbox size={18} />}
      title="Recordings Management Console"
      data-testid="recording-management-console-card"
      style={{ alignContent: 'start', overflow: 'hidden' }}
    >
      <Box display="grid" gap={4} overflow="auto">
        <DashboardCard
          title="Update Drives HW Version"
          description="Using Part to Rev mappings from HW Team"
          data-testid="recording-management-console-update-hw"
        >
          <Button
            minWidth="min-content"
            variant="outline"
            onClick={handleUpdateHWVersion}
          >
            Update HW Version
          </Button>
        </DashboardCard>
        <DashboardCard
          title="Fetch Stale Recordings"
          description="Stale: Processing for over 24 hours."
          data-testid="recording-management-console-fetch-stale"
        >
          <Button
            variant="outline"
            onClick={handleFetchStale}
            disabled={isLoading}
          >
            Fetch Recordings
          </Button>
        </DashboardCard>
        <DashboardCard
          title="Fetch Failed Recordings"
          description="Failed: OSF conversion failed."
          data-testid="recording-management-console-fetch-failed"
        >
          <Button
            variant="outline"
            onClick={handleFetchFailed}
            disabled={isLoading}
          >
            Fetch Recordings
          </Button>
        </DashboardCard>
      </Box>
    </DashboardCard>
  );
}
